export default [

     {
          path: '/phishing-category',
          name: 'PhishingCategory',
          component: () => import("@/views/Page/PhishingCategory/PhishingCategory.vue"),
           meta: {
               title: 'PhishingCategory',
          },
     },

     {
          path: '/phishing-website-page/:id',
          name: 'PhishingCategoryWebsistes',
          component: () => import("@/views/Page/PhishingCategory/PhishingWebsitePage.vue"),
           meta: {
               title: 'PhishingCategory Websites',
          },
     }
];